import { useMessages } from '@/i18n'
import { messages as previewMessages } from '@/features/editor/components/blocks/previews/messages'
import { useState } from 'react'
import { Play } from 'lucide-react'
import { useGetPostersQuery } from '@/features/editor/videosApi'
import { cn } from '@/lib/utils'

/**
 * Кадр ролика вместо чёрного экрана в миниатюре: активная обложка Kinescope —
 * по умолчанию это кадр, снятый с самого видео. Нет обложки (ролик ещё
 * обрабатывается, запрос упал) — прежний значок «плей».
 */
export const VideoPosterFrame = ({ videoId }: { videoId: string }) => {
  const m = useMessages(previewMessages)
  const { data: posters } = useGetPostersQuery(videoId)
  const poster = posters?.find((p) => p.active) ?? posters?.[0]
  // Горизонтальный кадр — целиком, с полями сверху и снизу (как на холсте в
  // режиме телефона), а не обрезанный по бокам до высоты экрана.
  const [landscape, setLandscape] = useState(false)
  return (
    <div
      aria-label={m.a11yVideo}
      role="img"
      className="relative flex h-full w-full items-center justify-center bg-black"
    >
      {poster ? (
        <img
          src={poster.md || poster.original}
          alt=""
          className={cn(
            'absolute inset-0 size-full',
            landscape ? 'object-contain' : 'object-cover',
          )}
          onLoad={(e) => setLandscape(e.currentTarget.naturalWidth > e.currentTarget.naturalHeight)}
        />
      ) : null}
      <Play className="relative h-12 w-12 text-white drop-shadow" />
    </div>
  )
}
